"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.HiddenIcon = (0, react_1.forwardRef)(function HiddenIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", 
            // eslint-disable-next-line max-len
            d: "M20.707 20.7074C20.8945 20.5199 20.9998 20.2656 20.9998 20.0004C20.9998 19.7352 20.8945 19.4809 20.707 19.2934L4.707 3.29341C4.5184 3.11125 4.2658 3.01045 4.0036 3.01273C3.7414 3.01501 3.49059 3.12018 3.30518 3.30559C3.11977 3.491 3.0146 3.74181 3.01233 4.00401C3.01005 4.2662 3.11084 4.5188 3.293 4.70741L5.205 6.62041C2.785 8.33841 1.5 10.6834 1.5 12.0004C1.5 14.2504 5.25 19.5004 12 19.5004C13.916 19.5004 15.59 19.0774 17.006 18.4204L19.293 20.7074C19.4805 20.8949 19.7348 21.0002 20 21.0002C20.2652 21.0002 20.5195 20.8949 20.707 20.7074ZM15.479 16.8934L13.705 15.1194C12.9597 15.4713 12.124 15.5844 11.3119 15.4433C10.4999 15.3021 9.75137 14.9136 9.16858 14.3308C8.5858 13.748 8.19727 12.9995 8.05611 12.1875C7.91496 11.3755 8.02808 10.5397 8.38 9.79441L6.644 8.05841C6.26049 8.3112 5.89617 8.59196 5.554 8.89841C4.28 10.0344 3.5 11.4174 3.5 12.0004C3.5 12.5844 4.281 13.9664 5.552 15.1034C7.231 16.6054 9.438 17.5004 12 17.5004C13.25 17.5004 14.417 17.2874 15.48 16.8934H15.479ZM20.32 16.0784C21.751 14.6104 22.5 13.0064 22.5 12.0004C22.5 9.75041 18.75 4.50041 12 4.50041C10.957 4.50041 9.985 4.62541 9.088 4.84641L10.809 6.56641C11.197 6.52341 11.594 6.50041 12 6.50041C14.562 6.50041 16.77 7.39541 18.448 8.89741C19.718 10.0344 20.5 11.4174 20.5 12.0004C20.5 12.5104 19.904 13.6304 18.905 14.6634L20.32 16.0784Z", fill: "currentColor" })));
});
